import React from 'react';
import { IfmsRoute }from '../../../config/types';

const Home = React.lazy(() => import('../Home'));

const routes:Array<IfmsRoute> = [
  {path: '/home/home', component: Home},
];

export default routes;
